import { AnalyticsDashboard } from "@/features/analytics/AnalyticsDashboard";
import { AnalyticsFiltersProvider } from "@/features/analytics/filters-context";

export default function AnalyticsPage() {
  return (
    <AnalyticsFiltersProvider>
      <AnalyticsDashboard />
    </AnalyticsFiltersProvider>
  );
}
